import { useEffect, useState } from 'react';
import { fetchOrderControlSettings } from '../services/api.ts';
import { ATENDABOT_ORDER_CONTROL_EVENT } from '../utils/orderControl.ts';

type UseAtendabotOrderControlOptions = {
  isFoodUser?: boolean;
  restauranteId?: string | number | null;
};

export function useAtendabotOrderControl({
  isFoodUser,
  restauranteId,
}: UseAtendabotOrderControlOptions = {}) {
  const [orderControlEnabled, setOrderControlEnabled] = useState(false);

  useEffect(() => {
    if (!isFoodUser) {
      setOrderControlEnabled(false);
      return undefined;
    }

    let cancelled = false;
    const loadOrderControl = async () => {
      try {
        const settings = await fetchOrderControlSettings();
        if (!cancelled) setOrderControlEnabled(settings?.pedidos_habilitados === true);
      } catch (error) {
        if (!cancelled) {
          setOrderControlEnabled(false);
          console.error('Erro ao verificar configuração de pedidos:', error);
        }
      }
    };

    loadOrderControl();
    return () => {
      cancelled = true;
    };
  }, [isFoodUser, restauranteId]);

  useEffect(() => {
    const updateOrderControl = (event: Event) => {
      const enabled = (event as CustomEvent)?.detail?.enabled;
      if (typeof enabled === 'boolean') setOrderControlEnabled(enabled);
    };
    window.addEventListener(ATENDABOT_ORDER_CONTROL_EVENT, updateOrderControl);
    return () => window.removeEventListener(ATENDABOT_ORDER_CONTROL_EVENT, updateOrderControl);
  }, []);

  return { orderControlEnabled };
}
